import { locacaoUsaPrecoMensal } from './constants/tipo-locacao';
import { CatalogCard } from './services/catalog-mappers';
import { PublicacaoAluguelApi, PublicacaoVendaApi } from './services/catalog-api.model';

export type LinhaVeiculo = 'Aluguel' | 'Assinatura' | 'Terceirização' | 'Seminovos';

export interface AnalyticsItem {
  item_id: string;
  item_name: string;
  item_category: LinhaVeiculo;
  price?: number;
  item_brand?: string;
}

export function linhaDeTipoLocacao(tipo: string | null | undefined): LinhaVeiculo {
  if (tipo === 'assinatura') {
    return 'Assinatura';
  }
  if (tipo === 'tercerizacao') {
    return 'Terceirização';
  }
  return 'Aluguel';
}

export function itemDeVenda(p: PublicacaoVendaApi): AnalyticsItem {
  const marca = p.veiculo?.modelo?.marca?.nome?.trim() ?? '';
  const modelo = p.veiculo?.modelo?.nome?.trim() ?? '';
  const nome = `${marca} ${modelo}`.trim()
    || (p.numero_anuncio ? `Anúncio #${p.numero_anuncio}` : 'Veículo');
  return {
    item_id: `venda-${p.id}`,
    item_name: cortar(nome),
    item_category: 'Seminovos',
    ...(p.preco != null ? { price: p.preco } : {}),
    ...(marca ? { item_brand: cortar(marca) } : {}),
  };
}

export function itemDeAluguel(p: PublicacaoAluguelApi): AnalyticsItem {
  const grupo = p.grupo?.nome?.trim() || p.categoria_legenda?.trim() || '';
  const codigo = p.grupo?.codigo?.trim();
  const nome = grupo
    ? (codigo ? `Grupo ${codigo} - ${grupo}` : grupo)
    : (p.titulo?.trim() || 'Aluguel');
  const preco = locacaoUsaPrecoMensal(p.tipo_locacao) ? p.preco_mensal : p.preco_diaria;
  const marca = p.modelo?.marca?.nome?.trim() ?? '';
  return {
    item_id: `aluguel-${p.id}`,
    item_name: cortar(nome),
    item_category: linhaDeTipoLocacao(p.tipo_locacao),
    ...(preco != null ? { price: preco } : {}),
    ...(marca ? { item_brand: cortar(marca) } : {}),
  };
}

export function itemDeCard(card: CatalogCard, linha: LinhaVeiculo): AnalyticsItem {
  const marca = card.make?.trim() ?? '';
  const grupo = card.btn?.trim() ?? '';
  const grupoEhLinha = grupo === 'Assinatura' || grupo === 'Tercerização' || grupo === 'Aluguel';
  let nome = card.title?.trim() || 'Veículo';
  if (card.modo === 'aluguel' && grupo && !grupoEhLinha) {
    nome = card.grupoCodigo ? `Grupo ${card.grupoCodigo} - ${grupo}` : grupo;
  }
  return {
    item_id: `${card.modo}-${card.id}`,
    item_name: cortar(nome),
    item_category: linha,
    ...(card.precoNumero != null ? { price: card.precoNumero } : {}),
    ...(marca ? { item_brand: cortar(marca) } : {}),
  };
}

function cortar(valor: string): string {
  return valor.length <= 100 ? valor : valor.slice(0, 100);
}
